import { Row, Table } from "react-bootstrap";

import classes from "../../purchase.module.scss";
import OrdersSaleTableHead from "./OrdersSaleTableHead";
import OrdersSaleTableBody from "./OrdersSaleTableBody";

const OrdersSaleTable = ({ data, setData, base, setBase }) => {
	return (
		<Row className={classes.table}>
			<Table className={classes.table_desktop}>
				<OrdersSaleTableHead base={base} setBase={setBase} />
				<OrdersSaleTableBody data={data} setData={setData} base={base} />
			</Table>
		</Row>
	);
};

export default OrdersSaleTable;
